import Head from "next/head";

import { CommonQuoteLandingContainer } from "@/containers/CommonQuoteLandingContainer";

/**
 * 네이버 검색광고 비즈채널용 공통 견적 LP
 * - URL: parlor.goifuneral.co.kr/quote/
 * - 광고 키워드: "{지역}장례식장" (지역 8개, utm으로 구분)
 * - 단일 정적 페이지
 */

const PAGE_TITLE = "장례 비용 안내 - 고이장례연구소";
const PAGE_DESCRIPTION =
  "장례 비용 가족장 기준 약 500~1,000만원. 빈소·식대·장례용품 항목별 견적을 1분 안에 무료로 확인하세요.";
const PAGE_CANONICAL = "https://parlor.goifuneral.co.kr/quote/";

const JSON_LD = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: PAGE_TITLE,
  description: PAGE_DESCRIPTION,
  url: PAGE_CANONICAL,
};

const ParlorCommonQuotePage = () => {
  return (
    <>
      <Head>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <link rel="canonical" href={PAGE_CANONICAL} />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:url" content={PAGE_CANONICAL} />
        <meta property="og:type" content="website" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(JSON_LD) }}
        />
      </Head>
      <CommonQuoteLandingContainer />
    </>
  );
};

export default ParlorCommonQuotePage;
